import { CPR_AUTH, CPR_BROWSERID, FAF_AUTH, FAF_BROWSERID } from "../constant/Constants";
import axiosCall from "./axiosCall";
import { resetSessionTiming } from "./sessionManagement";

//Get Funds List
export const fetchFundLists = async ({ patientID, zipCode, insuranceType, diagnosis, addressLine1, addressLine2, city, state, patientIsDeceased, DOB, isNewPatient, prgData }) => {
    const authorization = prgData == 'CPR' ? CPR_AUTH : FAF_AUTH;
    const params = new URLSearchParams({
        ContactId: patientID,
        DOB,
        ZipCode: zipCode,
        InsuranceType: insuranceType,
        Diagnosis: diagnosis,
        IsDeceased: patientIsDeceased,
        Undocumented: "false",
        FIPSCode: "",
        PortalType: "Partner",
        AddressLine1: addressLine1,
        AddressLine2: addressLine2,
        City: city,
        State: state,
        IsNewPatient: isNewPatient,
    });
    const response = await axiosCall('get', `/v1/data/D_EligibleFundsList?`, authorization, params.toString(), null, prgData);
    // const response = await axiosCall('get', `/v1/data/D_EligibleFundsList?`, authorization, `ContactId=${patientID}&DOB=${DOB}&ZipCode=${zipCode}&InsuranceType=${insuranceType}&Diagnosis=${diagnosis}&IsDeceased=${patientIsDeceased}&Undocumented=false&FIPSCode=''&PortalType=Partner&AddressLine1=${addressLine1}&AddressLine2=${addressLine2}&City=${city}&State=${state}&IsNewPatient=${isNewPatient}`, null, prgData);
    return response.data.pxResults
}

//Get PreQual Questions
export const fetchPreQualQuestions = async ({ fundID, fundGroup, patientID, zipCode, addressLine1, addressLine2, city, state, isNewPatient, prgData }) => {
    const authorization = prgData == 'CPR' ? CPR_AUTH : FAF_AUTH;
    const params = new URLSearchParams({
        FundID: fundID,
        FundGroup: fundGroup,
        ContactId: patientID,
        PortalType: "Partner",
        ZipCode: zipCode,
        AddressLine1: addressLine1,
        AddressLine2: addressLine2,
        City: city,
        State: state,
        IsNewPatient: isNewPatient,
    });
    const response = await axiosCall('get', `/v1/data/D_PreQualQuestionsService?`, authorization, params.toString(), null, prgData);
    // const response = await axiosCall('get', `/v1/data/D_PreQualQuestionsService?`, authorization, `FundID=${fundID}&FundGroup=${fundGroup}&ContactId=${patientID}&PortalType=Partner&ZipCode=${zipCode}&AddressLine1=${addressLine1}&AddressLine2=${addressLine2}&City=${city}&State=${state}&IsNewPatient=${isNewPatient}`, null, prgData);
    return response.data
}

//Validate PreQual Questions
export const validatePreQualQuestions = async ({ prequalObj, prgData }) => {
    resetSessionTiming()
    const authorization = prgData == 'CPR' ? CPR_AUTH : FAF_AUTH;
    let browserID = prgData == 'CPR' ? CPR_BROWSERID : FAF_BROWSERID;
    const response = await axiosCall('post', `/Applications/v1/PreQualValidate?`, authorization, `BrowserID=${browserID}`, prequalObj, prgData);
    return response.data
}

//Get Fund Specific Lookup
export const fundSpecificLookup = async ({ fundID, fundGroup, prgData }) => {
    const authorization = prgData == 'CPR' ? CPR_AUTH : FAF_AUTH;
    let browserID = prgData == 'CPR' ? CPR_BROWSERID : FAF_BROWSERID;
    const response = await axiosCall('get', `/v1/data/D_GetFundSpecificLookUpValues?`, authorization, `BrowserID=${browserID}&LookUpID=Stage&FundID=${fundID}&FundGroup=${fundGroup}`, null, prgData);
    return response.data.pxResults
}
